<template>
  <ankh-list>
    <template #btn-group>
      <el-button @click.native="handleSaveSubmit">{{$t('保存更改')}}</el-button>
      <el-button @click.native="$refs.treeTable.handleChangeExpandState()">{{ expandState ? $t('收起') : $t('展开') }}</el-button>
      <el-button @click.native="handleBatchDelete">{{$t('批量删除')}}</el-button>
    </template>

    <template #search-form>
      <el-form-item :label="$t('名称')">
        <el-input :placeholder="$t('名称')" v-model="searchForm.name" clearable/>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="handleSearch(searchForm.name)">{{$t('搜索')}}</el-button>
        <el-button @click="searchForm.name=''">{{$t('重置')}}</el-button>
      </el-form-item>
    </template>
    <template #table="{height}">

      <tree-table :column-list="columnList"
                  :data.sync="tableData"
                  disabledExpandByDefault
                  :expand.sync="expandState"
                  :height="height"
                  ref="treeTable"
                  :row-template="rowTemplate">

        <template #enName="{row}">
          <el-input :placeholder="$t('请输入')" v-model="row.enName"/>
        </template>

        <template #foodTag="{row}">
          <el-input :placeholder="$t('请输入')" v-model="row.foodTag"/>
        </template>

        <template #brandName="{row}">
          <el-input :placeholder="$t('请输入')" v-model="row.brandName"/>
        </template>

        <template #barCode="{row}">
          <el-input :placeholder="$t('请输入')" v-model="row.barCode"/>
        </template>

        <template #photo="{row}">
          <pic-upload
              :limit="1"
              width="80px"
              height="80px"
              v-model="row.photo"
              :download-url="$api.file.downloadImg"
              :action="$api.file.upload"/>
        </template>

        <template #operate="{row}">
          <div class="fb-link-flex">
            <el-link type="primary" :underline="false" @click="handleCheckOrAddEl(row)">{{$t('查看')}}</el-link>
            <el-link type="danger" :underline="false" @click="handleDelete(row)">{{$t('删除')}}</el-link>
          </div>
        </template>
      </tree-table>
    </template>
  </ankh-list>
</template>

<script>
import {request} from "@/config/request";
import PicUpload from "@/components/pic-upload/PicUpload";
import AnkhList from "@/components/list/AnkhList.vue";
import TreeTable from "@/components/tree-table/TreeTable.vue";
import {handleBuildTreeData, handleDeleteTip, handleDeleteTreeNode} from "@/utils/levelUtils";

export default {
  name: "FoodList",
  components: {TreeTable, AnkhList, PicUpload},
  data() {
    return {
      searchForm: {},
      tableData: [],
      renderTableData: [],

      expandState: true,

      columnList: [
        {label: "名称", prop: "name", type: "input", fixed: 'left', width: '400'},
        {label: "英文名称", prop: "enName", width: '300'},
        {label: "编码", prop: "foodTag", width: '300'},
        {label: "品牌名称", prop: "brandName", width: '300'},
        {label: "条形码", prop: "barCode", width: '300'},
        {label: "图片", prop: "photo",minWidth: "200"},
        {label: "移动", prop: "", type: "more",minWidth: "200"},
        {label: "默认展开", prop: "expand", type: "switch", width: "200"},
        {label: "创建时间", prop: "createTimeStr", width: "200"},
        {label: "操作", prop: "operate", width: "150"},
      ],

      // 新增row 需要的字段数据
      rowTemplate: {
        name: "",
        enName: "",
        foodTag: "",
        expand: "yes",
        photo: "",
        createTimeStr: this.$moment().format("YYYY-MM-DD HH:mm:ss"),
      },
    }
  },
  methods: {
    // 查看二级或添加元素
    handleCheckOrAddEl(row) {
      if (row.sub.length) {
        this.$router.push(`/food/detail/${row.code}`)
      } else {
        this.$router.push({
          path: "/food/addEl",
          query: {code: row.code}
        })
      }
    },

    // 保存
    async handleSaveSubmit() {
      try {
        let newParams = this.handleBuildParams(this.tableData)
        console.log("newParams", newParams)
        await request(this.$api.foodSort.save, newParams, {isJson: true});
        this.$message.success(this.$t('保存成功'));
        await this.handleSearch();
      } catch (e) {
        console.log(e);
      }
    },

    // 处理数据
    handleBuildParams(list) {
      return list.map((item, index) => {
        let sub = [];
        if (item.sub.length) {
          sub = this.handleBuildParams(item.sub);
        }
        return {
          name: item.name,
          enName: item.enName,
          foodTag: item.foodTag,
          barCode: item.barCode,
          brandName: item.brandName,
          code: item.isNewAdd ? null : item.code,
          sort: index + 1,
          expand: item.expand,
          photo: item.photo,
          letter: item.letter,
          sub,
        }
      })
    },

    async handleDelete(row) {
      try {
        await handleDeleteTip();
        if (!row.isNewAdd) {
          await request(this.$api.foodSort.delete, {code: row.code});
        }
        this.tableData = handleDeleteTreeNode([row.code], this.tableData);
        this.$message.success(this.$t('操作成功'));
      } catch (e) {
        console.error(e);
      }
    },

    async handleBatchDelete() {
      const selected = this.$refs.treeTable.handleGetSelected();
      if (!selected.length) {
        this.$message({
          type: 'warning',
          message: this.$t('未选择记录')
        });
        return;
      }

      try {
        await handleDeleteTip();
        let codes = selected.filter(f => !f.isNewAdd).map(item => item.code);
        if (codes.length) {
          await request(
              this.$api.foodSort.batchDelete,
              codes,
              {isJson: true},
          );
        }
        const delCodes = selected.map(item => item.code);
        this.$message.success(this.$t('操作成功'));
        this.tableData = handleDeleteTreeNode(delCodes, this.tableData);
      } catch (e) {
        console.error(e);
      }
    },


    // 搜索数据
    async handleSearch() {
      try {
        const params = {
          ...this.searchForm,
          onPage: false,
        }
        let res = await request(this.$api.foodSort.list, params);
        this.tableData = handleBuildTreeData(res.foodSorts, item => {
          item.createTimeStr = this.$moment(item.createTime).format("YYYY-MM-DD HH:mm:ss");
          return item;
        });
        this.$nextTick(() => {
          // this.$refs.treeTable.handleExpandByDefault();
        })
      } catch (e) {
        console.error(e);
      }
    },
  },
  mounted() {
    this.handleSearch();
  }

}
</script>

<style scoped>

</style>
